export default {
  colorPrimary: {
    backgroundColor: '#1f1f1f' 
  }
};

